/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionContext, Commit, Dispatch, Module } from "vuex";
import { RootState } from "@/store";
import dayjs from "dayjs";
import {
  readAll,
  countNotRead,
  getMessageList,
  deleteMessage,
  readMessage,
} from "@/api/userCenter";

type MessageItem = {
  id: number;
  userId: number;
  title: string;
  content: string;
  createTime: string;
  updateTime: string;
  isRead: boolean;
};
interface State {
  countNotRead: number;
  messageList: MessageItem[];
  messageListParams: {
    pageNo: number;
    pageSize: number;
  };
}

const store: Module<State, RootState> = {
  namespaced: true, // 为每个模块添加一个前缀名，保证模块命明不冲突
  state: () => {
    return {
      countNotRead: 0,
      messageList: [],
      messageListParams: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  mutations: {
    setCountNotRead(state: State, payload: number) {
      state.countNotRead = payload;
    },
    setMessageList(state: State, payload) {
      state.messageList = payload.data.map((item: any) => {
        return {
          ...item,
          createTime: dayjs(item.createTime).format("YYYY/MM/DD HH:mm:ss"),
        };
      });

      state.messageListParams = payload.page;
    },
  },
  actions: {
    async getNotReadCount({ commit }: { commit: Commit }) {
      try {
        const res = await countNotRead();
        commit("setCountNotRead", res);
      } catch (e) {
        log.error(e);
      }
    },
    async getMessageList(
      { commit, dispatch }: { commit: Commit; dispatch: Dispatch },
      payload: { pageNo: number; pageSize: number }
    ) {
      try {
        dispatch("getNotReadCount");
        const res = await getMessageList(payload);
        commit("setMessageList", res);
      } catch (e) {
        log.error(e);
      }
    },
    async deleteMessage(
      { dispatch, state }: ActionContext<State, RootState>,
      payload: {
        messageId: string;
        successCb: () => void;
      }
    ) {
      try {
        await deleteMessage({ messageId: payload.messageId });
        // dispatch("getMessageList", { pageNo: 1, pageSize: 10 });
        dispatch("getMessageList", state.messageListParams);
        payload.successCb();
      } catch (e) {
        log.error(e);
      }
    },
    async readMessage(
      { dispatch, state }: ActionContext<State, RootState>,
      payload: {
        messageId: number;
        successCb: () => void;
      }
    ) {
      try {
        await readMessage({ messageId: payload.messageId });
        dispatch("getNotReadCount");
        // dispatch("getMessageList", { pageNo: 1, pageSize: 10 });
        dispatch("getMessageList", state.messageListParams);
        payload.successCb();
      } catch (e) {
        log.error(e);
      }
    },
    async setAllRead(
      { dispatch, state }: ActionContext<State, RootState>,
      { successCb, errorCb }: { successCb: () => void; errorCb: () => void }
    ) {
      try {
        await readAll();
        // dispatch("getMessageList", { pageNo: 1, pageSize: 10 });
        dispatch("getMessageList", state.messageListParams);
        dispatch("getNotReadCount");
        successCb();
      } catch (e) {
        errorCb();
        log.error(e, "error");
      }
    },
  },
};

export default store;
